(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('WikiDetailController', WikiDetailController);

    WikiDetailController.$inject = ['$scope', '$stateParams', '$window', 'entity', 'space', 'Wiki', 'AlertService'];

    function WikiDetailController($scope, $stateParams, $window, entity, space, Wiki, AlertService) {
        var vm = this;
        vm.wiki = entity && entity.id ? entity : null;
        vm.space = space;
        vm.wikis = [];
        vm.reloadTree = reloadTree;
        vm.scrollToHeading = scrollToHeading;

        if (vm.space && vm.space.id) {
            $window.localStorage.setItem('wiki.lastSpaceId', vm.space.id);
        }

        reloadTree();

        $scope.$on('chamadosApp:wikiUpdate', function () {
            reloadTree();
        });

        function reloadTree() {
            Wiki.query({spaceId: vm.space.id}, function (data) {
                vm.wikis = data;
                refreshPageData();
            }, onError);
        }

        function findPagePath(pages, targetId, path) {
            path = path || [];
            for (var i = 0; i < pages.length; i++) {
                var page = pages[i];
                var currentPath = path.concat([{id: page.id, titulo: page.titulo}]);
                if (page.id === targetId) {
                    return currentPath;
                }
                if (page.filhos && page.filhos.length) {
                    var found = findPagePath(page.filhos, targetId, currentPath);
                    if (found) {
                        return found;
                    }
                }
            }
            return null;
        }

        function findPageNode(pages, targetId) {
            for (var i = 0; i < pages.length; i++) {
                if (pages[i].id === targetId) {
                    return pages[i];
                }
                if (pages[i].filhos) {
                    var found = findPageNode(pages[i].filhos, targetId);
                    if (found) {
                        return found;
                    }
                }
            }
            return null;
        }

        function slugify(text, index) {
            return 'wiki-h-' + index + '-' + (text || '').toLowerCase()
                .replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
        }

        function buildTocAndContent(html) {
            var toc = [];
            var index = 0;
            var rendered = (html || '').replace(/<(h[1-3])([^>]*)>(.*?)<\/\1>/gi, function (match, tag, attrs, text) {
                index++;
                var id = slugify(text.replace(/<[^>]+>/g, ''), index);
                var level = parseInt(tag.charAt(1), 10);
                toc.push({id: id, text: text.replace(/<[^>]+>/g, ''), level: level});
                return '<' + tag + ' id="' + id + '"' + attrs + '>' + text + '</' + tag + '>';
            });
            return {toc: toc, rendered: rendered};
        }

        function refreshPageData() {
            if (!vm.wiki || !vm.wiki.id || !vm.wikis.length) {
                vm.breadcrumbs = [];
                vm.toc = [];
                vm.renderedContent = vm.wiki ? vm.wiki.conteudo : '';
                vm.childPages = [];
                return;
            }
            var path = findPagePath(vm.wikis, vm.wiki.id) || [];
            vm.breadcrumbs = [{titulo: vm.space.nome}].concat(path);
            var node = findPageNode(vm.wikis, vm.wiki.id);
            vm.childPages = (node && node.filhos) ? node.filhos : [];
            var parsed = buildTocAndContent(vm.wiki.conteudo);
            vm.toc = parsed.toc;
            vm.renderedContent = parsed.rendered;
        }

        function scrollToHeading(id) {
            var el = document.getElementById(id);
            if (el) {
                el.scrollIntoView({behavior: 'smooth', block: 'start'});
            }
        }

        function onError(error) {
            if (error && error.data && error.data.message) {
                AlertService.error(error.data.message);
            }
        }
    }
})();
